import { getComponentKey } from 'utils/getComponentKey'

export const initialState = []
export const actionTypePrefix = 'dialogs'
export const actionTypes = {
  show: `${actionTypePrefix}/SHOW_DIALOG`,
  hide: `${actionTypePrefix}/HIDE_DIALOG`
}

export const actionCreators = {
  showDialog: (options) => ({ type: actionTypes.show, payload: options }),
  hideDialog: () => ({ type: actionTypes.hide })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.show: return [ ...state, { options: action.payload, dialogKey: getComponentKey() }]
    case actionTypes.hide: return state.slice(0, -1)
    default: return state
  }
}
